<template>

  <div>


    <app-header />


    <div class="container">

      <div class="my-3">
        <h1>{{_lang('New Project')}}</h1>
      </div>
      <!-- <div class="card border-primary">
          <div class="card-body">
            <form method="post" @submit.prevent="onSubmit">
              <input v-model="project.name" :placeholder="_lang('Project name')" type="text" class="form-control" required>
              <button type="submit" class="btn btn-primary">{{_lang('Start with a blank page')}}</button>
          </form>
        </div>
      </div>
 -->
      <div class="my-3">
        <h2>{{_lang('Themes')}}</h2>
      </div>
      <div class="card-listing templates">

				<div class="item">
          <div class="card">
          	<figure class="placeholder-blank">
          	</figure>
            <div class="card-header">
              <h5 class="text-truncate">{{_lang('Blank page')}}</h5>
            </div>
            <div class="card-body">
              <input v-model="project.name" :placeholder="_lang('Project name')" type="text" class="form-control" required>
            </div>
            <div class="card-footer text-center">
                <button class="btn btn-primary" @click.prevent="onSubmit">{{_lang('New Project')}}</button>
            </div>
          </div>
        </div>

        <div v-for="template in templates" class="item">
          <div class="card">
          	<figure>
	            <img class="card-img-top" v-if="template.thumbnail" :src="template.thumbnail" >
	            <img class="card-img-top" v-else src="/images/templates/gardenio-garden--landscape-design-moto-cms-3-template_96157-original.webp" >
	          </figure>
            <div class="card-header">
              <h5 class="text-truncate">{{ template.name }}</h5>
            </div>
            <div class="card-body">
              <p class="card-text">{{template.description}}</p>
              <p class="card-text  text-center">
                <a class="btn btn-sm btn-secondary" :href="'/template/'+template.id" target="_blank">
                  <svg class="icosvg" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z" />
                  </svg>
                  {{_lang('preview')}}
                </a>
              </p>
            </div>
            <div class="card-footer text-center">
                <button class="btn btn-primary" @click.prevent="useTemplate(template)">{{_lang('Use this theme')}}</button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>


</template>
<script>

  import componentFunctions from '../mixin.components.js'
  import axios from 'axios';
  import appHeader from '../components/appHeader.vue'

  export default {
    name: 'project-form',
    components:{
      appHeader,
    },
    mixins:[componentFunctions],
    data() {
      return {
        project:{
          name:'',
          favicon:'',
        },
      }
    },
    computed:{
      templates(){
        return this.$store.getters.templates;
      },
      user(){
        return this.$store.state.user;

      }
    },
    methods:{
      useTemplate(template){
        axios({
          method: 'post',
          url: '/api/templates/use/'+template.id,
          data:{name:this.project.name},
        }).then((res) => {
        	//if(this.user.email.match(/^demo/)){
        	this.$router.push('/project/'+res.data.id);
        }).catch(res=>{
          toastr('Error','Error','#cc0000');
        });
      },

      onSubmit(){
      	if(!this.project.name){
      		alert(this._lang('Project name is required'));
      		return;
      	}

        axios({
          method: 'post',
          url: '/api/projects',
          data: this.project
        }).then((res) => {
        	// if(this.user.email.match(/^demo/)){
          this.$router.push('/project/'+res.data.id);
        });
      },

    },
    mounted(){
      this.$store.dispatch('getTemplates');
    }

  }



</script>

<style scoped>


form { display: flex; align-items: center; }
form label { margin:0; }
form input { flex-grow:1; margin-right:10px;}
form button { flex-shrink:0;}
@media(max-width:991px){
  form button { font-size:14px;}
  form input { font-size:14px;}
}



</style>
